import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

const multiKnowledgeBaseSearchAtom = atom({
  key: RecoilAtomKey.multiKnowledgeBaseSearchKey,
  default: [],
});

const SingleKnowledgeBaseSearchAtom = atom({
  key: RecoilAtomKey.singleKnowledgeBaseSearchKey,
  default: [],
});

const GetFileListAtom = atom({
  key: RecoilAtomKey.getFileKey,
  default: [],
});
export { multiKnowledgeBaseSearchAtom, SingleKnowledgeBaseSearchAtom, GetFileListAtom };
